import { Row } from 'antd';
import React from 'react';
import Content from '../components/Content/Content';
import Phases from '../components/Phases/Phases';

const HomePage: React.FC = () => (
  <div className="page__wrapper home">
    <Row className=" fixed">
      <Row className="revers" type="flex" gutter={{ lg: 60 }}>
        <Phases col={{ lg: 12, xs: 24 }} />
        <Content col={{ lg: 12, xs: 24 }} />
      </Row>
    </Row>
  </div>
);

export default React.memo(HomePage);
